import React, {Dispatch, SetStateAction} from 'react';
import {useTranslation} from 'react-i18next';
import {ThemedCalendar} from '../Calendar/ThemedCalendar';
import {tab} from "../MyBets/MyBets";
import {RoundedTabs} from "../tabs/RoundedTabs";

export interface SelectorContentTabsProps {
    currentTab: tab
    setCurrentTab: Dispatch<SetStateAction<tab>>
    date: Date
    setDate: Dispatch<SetStateAction<Date>>
}

export const SelectorContentTabs: React.FC<SelectorContentTabsProps> = ({currentTab, setCurrentTab, date, setDate}) => {
    const {t} = useTranslation();
    const tabs = [
        {value: 'allBets' as tab, label: t('myBets.selector.allBets')},
        {value: 'calculated' as tab, label: t('myBets.selector.calculated')},
        {value: 'notCalculated' as tab, label: t('myBets.selector.notCalculated')}
    ];

    const handleChange = (newValue: tab) => setCurrentTab(newValue)

    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 14);

    return (
        <div>
            <div className="flex justify-between flex-col-reverse tablet:flex-row">
                <RoundedTabs<tab>
                    value={currentTab}
                    onChange={handleChange}
                    tabs={tabs}
                />
                <div className="flex justify-between">
                    <div className="tablet:hidden font-bold self-start mobile:px-4">
                        <h2>{t("Steps")}</h2>
                    </div>

                    <div className='content-center mobile:px-4'>
                        <ThemedCalendar
                            selectedDate={date}
                            callback={setDate}
                            minDate={minDate}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
